import * as React from "react";
import MyChartDataTile from "../dashboard/MyChartDataTile";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import ProxySetup from "../proxyManagement/ProxySetup";
import * as d from "../../reducers/domainReducer";
import { getFirstName } from "../../helpers/formatting";
import * as msgs from "../../constants/textConstants";
import { Link } from "react-router-dom";
import { Typography, Notifier } from "../ecosystem";
import { PageHeading } from "../ecosystem/mybswh";
class ProxyManagement extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ProxyManagement.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        let { serverData, hasMyChart, location, rxDown, epicEHRDown, myChartRegistrationUrl, technicalHelpDeskNumber, technicalHelpDeskHours, currentMyChartUser, isProxyUser, screenBreakPoint, removeBSWPharmacy } = this.props;
        const referrer = location && location.state && location.state.referrer ? location.state.referrer : null;
        let showForPrimaryUser = false;
        let markup = "";
        let displayName = "";
        let isMinor = "";
        const technicalAssistanceMsg = `For assistance, call the MyBSWHealth technical help desk ${technicalHelpDeskHours} at `;
        const isMobile = ([msgs.XS_MOBILE, msgs.SM_MOBILE, msgs.MD_TABLET, msgs.LG_TABLET, msgs.XL_DESKTOP]).indexOf(screenBreakPoint) > -1 ? true : false;

        if (isProxyUser && currentMyChartUser) { //user is mychart proxy, so take age and show the appropriate message.            
            const isAdult = currentMyChartUser && currentMyChartUser.ageYears && currentMyChartUser.ageYears >= 14;
            isMinor = currentMyChartUser && currentMyChartUser.ageYears && currentMyChartUser.ageYears >= 0 && currentMyChartUser.ageYears <= 13;
            displayName = currentMyChartUser && currentMyChartUser.firstName ? currentMyChartUser.firstName : currentMyChartUser ? getFirstName(currentMyChartUser.displayName) : "";
            if (isAdult) {
                markup = (<div className="col-12">
                    <label>
                        {displayName} must manage their family access within their own MyBSWHealth account. If they do not have one they can create one <Link to={{ pathname: myChartRegistrationUrl }} target="_blank">here</Link>.<br /><br />
                        {technicalAssistanceMsg} <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.
                            </label>
                </div>);
            }
            else if (isMinor) {
                markup = (<div className="col-12">
                    <label>
                        {displayName} cannot manage their family access within MyBSWHealth. They must be at least 14 years old.<br /><br />
                        {technicalAssistanceMsg} <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.
                            </label>
                </div>);
            } else { // if age is unknown for mychart proxies.
                markup = (<div className="col-12">
                    <label>
                        {displayName} must manage their family access within their own MyBSWHealth account. They must be at least 14 years old to have an account and can create one <Link to={{ pathname: myChartRegistrationUrl }} target="_blank">here</Link>.<br /><br />
                        {technicalAssistanceMsg} <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.
                        </label>
                </div>);
            }
        } else {
            showForPrimaryUser = true;  // user is primary user.
        }
        return (
            <div className="container-fluid body-content proxy-mgmt-container">
                <div className="row">
                    <div className={"col-12 maxWidth-content " + (removeBSWPharmacy ? " proxy-mgmt-home-banner" : "")}>
                        {removeBSWPharmacy &&
                            <Notifier icon="information">
                                Your Pharmacy Records and Medical Records have been combined.
                            </Notifier>
                        }
                       
                    </div>
                </div>
                {showForPrimaryUser ?
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <div className="row">
                                <div className="col-12">
                                    <PageHeading
                                        heading="Family Account Management"
                                    />
                                </div>
                            </div>
                            <ProxySetup referrer={referrer} isMobile={isMobile} />

                            {/*hasMyChart &&
                                <div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h2 className="page-heading section-heading dt-heading">Medical Records</h2>
                                        </div>
                                    </div>
                                    {!epicEHRDown ?
                                        <MyChartDataTile mode="proxyaccess" title="Medical Records Family Accounts" navigation="hide" serverData={serverData} partialView />
                                        :
                                        <SectionLoadingError sectionErrorClass="errorSectionClass" message=" Medical record accounts are unavailable. Please try again later." />
                                    }
                                </div>
                            */}
                        </div>
                    </div>

                    : (<div className="row">
                        <div className="col-12 maxWidth-content">
                            <div className="row">
                                <div className="col-12">
                                    <PageHeading
                                        heading="Family Account Management"
                                        proxyName={isMinor ? "Minor" : displayName}
                                    />
                                </div>
                                {markup}
                            </div>
                        </div>
                    </div>
                    )}
            </div>);
    }
}

const mapStateToProps = (state) => {
    return {
        hasMyChart: state.domain.hm,
        serverData: state.session.serverData,
        rxDown: state.common.rxDown,
        epicEHRDown: state.common.epicEHRDown,
        myChartRegistrationUrl: state.session.serverData && state.session.serverData.myChartRegistrationUrl,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours : "",
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false,

        screenBreakPoint: state.common.screenBreakPoint,
        isProxyUser: state.domain.ip
    };
};

export default connect(mapStateToProps)(ProxyManagement);